package com.milta.feature.route.domain.usecase

import com.milta.core.network.ApiException
import com.milta.feature.route.domain.repository.RouteRepository

private const val HTTP_NOT_FOUND = 404

/**
 * DELETE /api/v1/route-batches/{id} — retour 26/10 (demande 2, R8): the split must be recomputed
 * while a batch not sent yet exists, so that batch is abandoned first (its routes deleted
 * server-side). A 404 means it is already gone: treated as abandoned. A batch already sent answers
 * 409 `error.route_batch_already_dispatched` and is never abandoned (thrown to the caller).
 */
class DeleteRouteBatchUseCase(private val repository: RouteRepository) {
    suspend operator fun invoke(batchId: String) {
        try {
            repository.deleteRouteBatch(batchId)
        } catch (e: ApiException) {
            if (e.statusCode != HTTP_NOT_FOUND) throw e
        }
    }
}
